<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="StudentReqForm" @submit.prevent>
        <v-card>
          <v-card-title
            class="d-flex align-center"
            style="background-color: #2196f3 !important; color: #ffffff"
          >
            <span>{{ action }} Student Data</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 800px" class="">
            <!-- <v-container> -->
            <div style="height: 88vh; position: relative">
              <div
                class="d-flex justify-center align-center elavation-2 ml-4"
                style="
                  border: 1px solid grey;
                  width: 250px;
                  height: 250px;
                  border-radius: 100%;
                  position: relative;
                  background-color: white;
                "
              >
                <img
                  src="../../../assets/img/img_avatar.png"
                  alt=""
                  style="width: 100%; border-radius: 100%; position: absolute"
                />
              </div>
              <div
                style="
                  border: 1px solid #e3e3e3;
                  height: auto;
                  margin-top: -110px;
                  background: #f0fff0;
                "
                class="rounded-lg"
              >
                <div style="margin-top: 150px" class="mx-4">
                  <div class="text-h4 font-weight-bold">
                    Personal Details
                    <span
                      ><v-icon size="30"
                        >mdi-information-variant-circle-outline</v-icon
                      ></span
                    >
                  </div>

                  <v-row class="mt-6">
                    <v-col cols="4">
                      <v-text-field
                        readonly
                        v-model="fname"
                        label="First Name"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                    <v-col cols="4">
                      <v-text-field
                        readonly
                        v-model="mname"
                        label="Middle Name"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                    <v-col cols="4">
                      <v-text-field
                        readonly
                        v-model="lname"
                        label="Last Name"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="suffix"
                        readonly
                        label="Suffix"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                    <v-col cols="4">
                      <v-text-field
                        readonly
                        v-model="bdate"
                        label="Birthdate"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                    <v-col cols="4">
                      <v-text-field
                        readonly
                        v-model="sex"
                        label="Sex"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                    <v-col cols="6">
                      <v-text-field
                        readonly
                        v-model="progName"
                        label="Course"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                    /></v-col>
                  </v-row>
                </div>
                <div style="margin-top: 50px" class="mx-4 mb-4">
                  <div class="text-h4 font-weight-bold">
                    Requirements
                    <span
                      ><v-icon size="30"
                        >mdi-information-variant-circle-outline</v-icon
                      ></span
                    >
                  </div>

                  <v-row class="mt-2">
                    <v-col cols="12">
                      <v-card elevation="2" class="pa-2">
                        <v-data-table
                          :headers="headers"
                          :items="itemdata"
                          hover
                          density="compact"
                          class="rounded-lg"
                        >
                          <template v-slot:[`item.createdAt`]="{ item }">
                            {{ formatDate(item.createdAt) }}
                          </template>
                          <template v-slot:[`item.submitted_status`]="{ item }">
                            <v-chip
                              size="x-small"
                              v-if="item.submitted_status == 1"
                              >For Approval
                            </v-chip>
                            <v-chip
                              size="x-small"
                              color="blue"
                              class="text-white"
                              v-if="item.submitted_status == 2"
                              >Approved
                            </v-chip>
                            <v-chip
                              size="x-small"
                              color="red"
                              class="text-white"
                              v-if="item.submitted_status == 3"
                              >Disapproved</v-chip
                            >
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip text="View" location="top">
                              <template #activator="{ props }">
                                <v-btn
                                  icon
                                  color="primary"
                                  variant="text"
                                  v-bind="props"
                                  @click="viewItem(item)"
                                >
                                  <v-icon>mdi-eye</v-icon>
                                </v-btn>
                              </template>
                            </v-tooltip>

                            <!-- <v-tooltip text="Delete" location="top">
                              <template #activator="{ props }">
                                <v-btn
                                  icon
                                  color="error"
                                  variant="text"
                                  v-bind="props"
                                  @click="deleteItem(item)"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                            </v-tooltip> -->
                          </template>

                          <template #no-data> No data found. </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <div style="margin-top: 50px" class="mx-4 mb-4">
                  <div class="text-h4 font-weight-bold">
                    Submissions
                    <span
                      ><v-icon size="30"
                        >mdi-information-variant-circle-outline</v-icon
                      ></span
                    >
                  </div>

                  <v-row class="mt-2">
                    <v-col cols="12">
                      <v-card elevation="2" class="pa-2">
                        <v-data-table
                          :headers="submission_headers"
                          :items="submissionData"
                          hover
                          density="compact"
                          class="rounded-lg"
                        >
                          <template v-slot:[`item.createdAt`]="{ item }">
                            {{ formatDate(item.createdAt) }}
                          </template>
                          <template v-slot:[`item.submitted_status`]="{ item }">
                            <v-chip
                              size="x-small"
                              v-if="item.submitted_status == 1"
                              >For Approval
                            </v-chip>
                            <v-chip
                              size="x-small"
                              color="blue"
                              class="text-white"
                              v-if="item.submitted_status == 2"
                              >Approved
                            </v-chip>
                            <v-chip
                              size="x-small"
                              color="red"
                              class="text-white"
                              v-if="item.submitted_status == 3"
                              >Disapproved</v-chip
                            >
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip text="View" location="top">
                              <template #activator="{ props }">
                                <v-btn
                                  icon
                                  color="primary"
                                  variant="text"
                                  v-bind="props"
                                  @click="viewItem(item)"
                                >
                                  <v-icon>mdi-eye</v-icon>
                                </v-btn>
                              </template>
                            </v-tooltip>

                            <!-- <v-tooltip text="Delete" location="top">
                              <template #activator="{ props }">
                                <v-btn
                                  icon
                                  color="error"
                                  variant="text"
                                  v-bind="props"
                                  @click="deleteItem(item)"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                            </v-tooltip> -->
                          </template>

                          <template #no-data> No data found. </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div style="position: absolute; bottom: 20px; right: 20px">
                <!-- <div>
                    <v-btn
                      :color="$vuetify.theme.themes.light.submitBtns"
                      @click="updateDetails = !updateDetails"
                    >
                      {{ !updateDetails ? "Update" : "Save" }}</v-btn
                    >
                  </div> -->
              </div>
            </div>
            <!-- </v-container> -->
          </v-card-text>
          <!-- <v-divider></v-divider> -->

          <!-- <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              :readonly="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions> -->
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="studentRequirementDialog"
      eager
      persistent
      scrollable
      max-width="800"
    >
      <v-card>
        <v-card-title
          class="d-flex align-center"
          style="background-color: #2196f3 !important; color: #ffffff"
        >
          <span>Requirement</span>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            color="white"
            @click="studentRequirementDialog = false"
          >
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  readonly
                  v-model="reqName"
                  label="Requirement Name"
                  :color="$vuetify.theme.themes.light.inputColor"
                  variant="outlined"
                  density="compact"
                />
              </v-col>
              <v-col cols="12">
                <v-btn
                  :color="$vuetify.theme.themes.light.submitBtns"
                  @click="viewFile()"
                  class="white--text"
                  density="comfortable"
                  variant="flat"
                >
                  <v-icon>mdi-eye</v-icon>
                  View File Submitted
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions
          class="pa-2 mr-4"
          v-if="itemToView && itemToView.submitted_status == 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="disapproveDialog = true">
            <v-icon>mdi-close-circle-outline</v-icon>
            Disapprove
          </v-btn>
          <v-btn
            @click="warningDialog = true"
            :color="$vuetify.theme.themes.light.submitBtns"
            class="white--text"
            density="comfortable"
            variant="flat"
          >
            <v-icon>mdi-check-circle</v-icon>
            Approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- disapprove dialog -->
    <v-dialog
      v-model="disapproveDialog"
      eager
      persistent
      scrollable
      max-width="500"
    >
      <v-form ref="disapproveRef" @submit.prevent>
        <v-card>
          <v-card-title
            class="d-flex align-center"
            style="background-color: #f44336 !important; color: #ffffff"
          >
            <span>Disapprove</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="disapproveDialog = false"
            >
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="remarks"
                    label="Remarks"
                    :rules="[formRules.required]"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                    rows="5"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="cancelDisapprove()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              @click="saveDisapproval()"
              class="white--text"
              density="comfortable"
              variant="flat"
              :readonly="btnLoading"
              :loading="btnLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- warning dialog -->
    <v-dialog
      v-model="warningDialog"
      eager
      persistent
      scrollable
      max-width="500"
    >
      <v-card color="white">
        <div class="pa-4">
          <div class="text-h6 mb-1">WARNING!</div>

          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to APPROVE this submission?
            </p>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="warningDialog = false">
            Close
          </v-btn>

          <v-btn
            :color="$vuetify.theme.themes.light.submitBtns"
            class="white--text"
            density="comfortable"
            variant="flat"
            @click="approve()"
            :readonly="btnLoading"
            :loading="btnLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      warningDialog: false,
      dialog: false,
      btnLoading: false,
      studentRequirementDialog: false,
      disapproveDialog: false,
      remarks: null,
      showDatePicker: false,
      itemToView: null,
      reqName: null,
      fname: null,
      mname: null,
      lname: null,
      suffix: null,
      bdate: null,
      sex: null,
      progName: null,
      deletedFile: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      headers: [
        { title: "Name", value: "requirements.name", align: "start" },
        { title: "Date Submitted", value: "createdAt", align: "center" },
        { title: "Status", value: "submitted_status", align: "center" },

        {
          title: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: 200,
        },
      ],
      submission_headers: [
        { title: "Name", value: "name", align: "start" },
        { title: "Date Submitted", value: "createdAt", align: "center" },
        { title: "Status", value: "submitted_status", align: "center" },

        {
          title: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: 200,
        },
      ],
      itemdata: [],
      submissionData: [],
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        this.$refs.StudentReqForm.resetValidation();
        if (data.id) {
          console.log("StDAta", data);
          this.getStudentRequirements(data.id);
          this.fname = data.fname;
          this.mname = data.mname;
          this.lname = data.lname;
          this.suffix = data.suffix;
          this.bdate = data.bdate;
          this.sex = data.sex;
          this.progName = data.program.name;
        }
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.getPrograms();
    },

    viewItem(item) {
      console.log(item);
      this.studentRequirementDialog = true;
      this.reqName = item.requirements.name;
      this.itemToView = item;
    },

    previewFile() {
      //  let url =
      //   process.env.VUE_APP_SERVER +
      //   "/pdf-generator/generateDTR/" +
      //   this.id +
      //   "/" +
      //   mnthyr +
      //   "/" +
      //   period;

      window.open("sample_file");
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    deleteFile() {
      console.log(typeof this.moa_file);
      if (typeof this.moa_file == "string") {
        this.deletedFile = this.moa_file;
      }

      this.moa_file = null;
      this.file_desc = null;
      this.valid_until = null;
    },

    async save() {
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          name: this.name,
          program_id: this.$store.state.user.program_id,
        };

        this.axiosCall("/student-requirement", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      this.btnLoading = true;
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        let data = {
          name: this.name,
        };
        this.axiosCall(
          "/student-requirement/" + this.data.id,
          "PATCH",
          data
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      } else {
        this.btnLoading = false;
      }
    },
    closeD() {
      eventBus.emit("closeViewStudentDialog", true);
      this.dialog = false;
    },

    closeDialogs() {
      this.warningDialog = false;
      this.studentRequirementDialog = false;
      this.disapproveDialog = false;
    },

    approve() {
      this.btnLoading = true;
      this.axiosCall(
        "/student-requirement-submission/approve/" + this.itemToView.id,
        "PATCH"
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
          this.btnLoading = false;
          this.closeDialogs();
          this.getStudentRequirements(this.data.id);
        } else {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },

    cancelDisapprove() {},
    async saveDisapproval() {
      let valid = await this.$refs.disapproveRef.validate();

      if (valid.valid) {
        this.btnLoading = true;
        let data = {
          remarks: this.remarks,
          id: this.itemToView.id,
        };

        this.axiosCall(
          "/student-requirement-submission/saveDisapproval",
          "POST",
          data
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeDialogs();
            this.getStudentRequirements(this.data.id);
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    getStudentRequirements(studentID) {
      this.axiosCall(
        "/student-requirement-submission/" + studentID,
        "GET"
      ).then((res) => {
        console.log(res.data);
        this.itemdata = res.data;
      });
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    viewFile() {
      let url =
        process.env.VUE_APP_SERVER +
        "/student-requirement-submission/get-file/" +
        this.itemToView.filename;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
          // window.open(_url, "_blank").focus();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
      // window.open(url);
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
